var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeOrientationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.97489C23 5.92469 19.7407 2.24268 15.0329 2.24268L17.2058 4.82008M1 14.3933C1 18.4435 4.25926 22.1255 8.96708 22.1255L6.79424 19.5481M8.2428 1L22.6379 15.636L15.3951 23L1 8.36402L8.2428 1Z",
    stroke: "currentColor",
    strokeWidth: 1.69284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeOrientationIcon);
export default __webpack_public_path__ + "static/media/change-orientation-icon.416fdc64c6215448790982d09447459e.svg";
export { ForwardRef as ReactComponent };